import { FormProps } from '@omilia/chat-ui';
import ih from 'immutability-helper';
import { ReopenMinimiziedChat } from 'types';
import { getUrlDomain } from 'utils/getUrlDomain';

import * as types from './actionTypes';
import initialState from './initialState';

interface actionInterface {
  type?: string;
  payload?: {
    token?: string;
    apiUrl?: string;
    config?: {
      enableResetButton: boolean;
      shouldReopenMinimizedChat: ReopenMinimiziedChat;
      dataPersistent: boolean;
      enableConsecutiveDialogs: boolean;
      welcomeForm: FormProps;
    };
    isMutedSound?: boolean;
    persistentData?: Record<string, any>;
  };
}

export default (state = initialState, action: actionInterface = {}) => {
  switch (action.type) {
    case types.SET_API_URL_DOMAIN:
      return ih(state, {
        apiUrlDomain: {
          $set: getUrlDomain(action.payload.apiUrl),
        },
      });
    case types.SET_TOKEN:
      return ih(state, {
        token: {
          $set: action.payload.token,
        },
      });
    case types.SET_CHAT_CONFIG:
      return ih(state, {
        config: { $set: action.payload.config },
      });
    case types.UPDATE_CHAT_CONFIG:
      return ih(state, {
        config: { $merge: action.payload.config },
      });
    case types.SET_PERSIST_CHAT_DATA:
      return ih(state, {
        persistentData: { $set: action.payload.persistentData },
      });
    case types.TOGGLE_SOUND_NOTIFICATIONS:
      return ih(state, {
        $toggle: ['isMutedSound'],
      });
    default:
      return state;
  }
};
